
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsbb6fe218985901f9eb159e5a5ce7d15cen from './en.yaml'
            i18n.addResourceBundle('en', 'bb6fe218985901f9eb159e5a5ce7d15c', flattenObject(nsbb6fe218985901f9eb159e5a5ce7d15cen), true, true);
        
        export default 'bb6fe218985901f9eb159e5a5ce7d15c';
    